import { connect } from 'react-redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { setPreviousUrl } from '~src/bootstrap/redux/actions/SetPreviousUrlReducerAction';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { contentCountsUpToDate } from '~src/spacesPlatform/actions/ContentCountsActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { PublishedConnectionSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { enterPublishedConnectionSubspace } from '../actions/EnterPublishedConnectionSubspaceAction';
import { publishedConnectionCountsRequest } from '../actions/PublishedConnectionCountsRequestAction';
import {
  PublishedConnectionSpace,
  PublishedConnectionSpaceDispatchProps,
  PublishedConnectionSpaceOwnProps,
  PublishedConnectionSpaceStateProps,
} from './PublishedConnectionSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionSpaceStateProps> = (state) => ({
  contentCountsPublishedConnection: selectContentCounts<'virtualConnection'>(state, 'virtualConnection'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isServerOrSiteAdmin: CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionSpaceDispatchProps, PublishedConnectionSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionSubspace(
      ownProps.publishedConnectionDetailInfo,
      ownProps.subplaceName as PublishedConnectionSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionCountsRequest('virtualConnection'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
  setPreviousUrl
});

export const ConnectedPublishedConnectionSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionSpace);
